import { AccountCircle, PowerSettingsNew } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import { useAppSelector } from 'common/context/hooks';

type BranchListHeaderProps = {
  onLogout: () => void;
};

export const BranchListHeader = ({ onLogout }: BranchListHeaderProps) => {
  const theme = useTheme();
  const auth = useAppSelector((state) => state.common.auth);
  const brand = useAppSelector((state) => state.common.brand);

  return (
    <Box
      sx={{
        mb: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flex: 1,
          minWidth: { xs: '100%', md: 'auto' },
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
              mb: 0.5,
            }}
          >
            Şube Yönetimi
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            Çalışmak istediğiniz şubeyi seçin
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        {brand && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            }}
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: theme.palette.primary.main,
                fontSize: '0.875rem',
              }}
            >
              {brand.name?.charAt(0)?.toUpperCase() || 'B'}
            </Avatar>
            <Box>
              <Typography
                variant="caption"
                sx={{
                  display: 'block',
                  color: theme.palette.text.secondary,
                  fontSize: '0.7rem',
                  lineHeight: 1,
                }}
              >
                Marka
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  fontSize: '0.875rem',
                  lineHeight: 1.2,
                }}
              >
                {brand.name || 'Marka Adı'}
              </Typography>
            </Box>
          </Box>
        )}

        {auth && (
          <>
            <Divider orientation="vertical" flexItem />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 2,
                py: 1,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              <AccountCircle
                sx={{
                  fontSize: 32,
                  color: theme.palette.primary.main,
                }}
              />
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    display: 'block',
                    color: theme.palette.text.secondary,
                    fontSize: '0.7rem',
                    lineHeight: 1,
                  }}
                >
                  Kullanıcı
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                    fontSize: '0.875rem',
                    lineHeight: 1.2,
                  }}
                >
                  Admin
                </Typography>
              </Box>
            </Box>
          </>
        )}

        <Button
          variant="outlined"
          color="error"
          startIcon={<PowerSettingsNew />}
          onClick={onLogout}
          sx={{
            borderRadius: 2,
            px: 2.5,
            py: 1,
            textTransform: 'none',
            fontWeight: 600,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              backgroundColor: alpha(theme.palette.error.main, 0.08),
            },
          }}
        >
          Çıkış Yap
        </Button>
      </Box>
    </Box>
  );
};

